// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"d5fc5995","251":"f39215f6","289":"abeb7c5b","512":"4e9fb90c","539":"d0382654","701":"c3f44bf4","777":"291a85ce","993":"1ebefb1e"}[chunkId] + ".chunk.js";
};